import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { AnalyticsControl as Component } from './analytics-control';
import type { TAnalyticsControl } from './models';

export const AnalyticsControl = createWidget<unknown, TAnalyticsControl>({})(Component);
